<template>
    <div>
        <v-row class="bradcrumb">
            <router-link :to="{name: 'role-links' }" class="root">
                Dashboard
            </router-link>
            <span class="child">/ Overall Quiz Dashboard </span>
        </v-row>
        <br />
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
                <v-overlay :value="loader" absolute>
			Loading
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
        <v-card class="card">
            <v-card-title class="heading justify-center">
                <span><h3>Overall Quiz Dashboard</h3></span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4">
                        <v-select label="Academic Year" variant="outlined" :items="aylist" v-model="ay"
                            item-value="ay" item-text="ay" required="true"
                            :rules="[v => !!v || 'Required']"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-select label="Semester" variant="outlined" :items="semlist" v-model="sem"
                            item-value="sem" item-text="sem" required="true"
                            :rules="[v => !!v || 'Required']"></v-select>
                    </v-col>
                    <v-col cols="12" sm="4" style="text-align: left;">
                        Date : <datetime format="DD-MM-YYYY" width="100px" v-model="date"></datetime>

                    </v-col> 
                </v-row>   
                <v-row> 
                    <v-col cols="12" sm="4" style="padding:25px;"></v-col>
                    <v-col cols="12" sm="4" style="padding:25px;">
                        <v-btn :loading = "dialog"   class="button"  @click="proceed()">
                            Fetch
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" style="padding:25px;"></v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <br />
        <div v-if="displaytable">
            <v-card class="card">
                <v-card-text v-if="erpcourseofferinginstructorlist.length!=0">
                    <v-simple-table>
                            <thead>
                                <tr color="green">
                                    <th>S.No.</th>
                                    <th>Course Name</th>
                                    <th>Program</th>
                                    <th>Year</th>
                                    <th>Quiz Name</th>
                                    <th>Exam Date</th>
                                    <th>Slot</th>
                                    <th>Question Bank</th>
                                    <th>Quiz Dashboard</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in erpcourseofferinginstructorlist" :key="index">
                                    <td>{{index+1}}</td>
                                    <td>{{item.course_name}}</td>
                                    <td>{{item.program}}</td>
                                    <td>{{item.year}}</td>
                                    <td>{{item.quizname}}</td>
                                    <td>{{item.examdate}}</td>
                                    <td>{{item.slot}}</td>
                                    <td v-if="item.questioncount!=0">{{item.questioncount}}</td>
                                    <td style="font-size:18px;padding:5px;color:red;" v-else>Questions Not Added.</td>
                                    <td>
                                        <center>
                                            <v-btn v-if="item.enable_flag == true"
                                                class="button"
                                                @click="proceedToOverallQuizMonitoring(item.id,item.courseofferingid)"
                                                >Proceed
                                            </v-btn>
                                            <v-btn disabled v-else class="button">Exam is not Active</v-btn>
                                        </center>
                                    </td>
                                </tr>
                            </tbody>
                    </v-simple-table>
                </v-card-text>
                <v-card-text v-else>
                    <h3>No Quiz Timetable Found</h3>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import { VueMathjax } from "vue-mathjax";
    import datetime from 'vuejs-datetimepicker'
    import MathLive from "mathlive";
import loader from "sass-loader";
    export default {
        components: {
            "vue-mathjax": VueMathjax,
            "datetime":datetime,
        },
        data: () => ({
            aylist: [],
            semlist: [],
            ay: null,
            sem: null,
            snackbar_msg: "",
            loader: false,
            displaytable:false,
            erpcourseofferinginstructorlist:[],
            dialog : false,
            date:"",
        }),
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.dialog = true;
                axios
                    .post("QuizDashboard/quizAySemFilter")
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.aylist = res.data.aylist;
                            this.semlist = res.data.semlist;
                            this.ay = res.data.ay;
                            this.sem = res.data.sem;
                            this.displaytable = false;
                            this.dialog = false;
                        } else {
                            this.showSnackbar(res.data.msg, "#b71c1c");
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("Something Went Wrong...", "#b71c1c");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            proceed() {
                if (this.date == null || this.date == "") {
                    this.showSnackbar("#b71c1c", "Please Select date");
                    return
                }
                const data = {
                    ay: this.ay,
                    sem: this.sem,
                    date:this.date,
                };
                this.dialog = true;
                axios
                    .post("QuizDashboard/displaysubjectForQuizDashboard", data)
                    .then((res) => {
                        if (res.data.status == "200" && res.data.msg == "success") {
                            this.erpcourseofferinginstructorlist = res.data.erpcourseofferinginstructorlist;
                            this.displaytable = true;
                            this.dialog = false;
                        } else {
                            this.showSnackbar(res.data.msg, "#b71c1c");
                            this.dialog = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("Something Went Wrong...", "#b71c1c");
                        this.dialog = false;
                    })
                    .finally(() => {
                        this.dialog = false;
                    });
            },
            proceedToOverallQuizMonitoring(slotid,courseofferingid) {
                this.$router.push({ name: "overall-quiz-live-dashboard", params: {slotid: slotid,courseofferingid:courseofferingid,date:this.date} });
                window.open(routeData.href, '_blank');
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
    thead {
        background-color: hsla(190, 99%, 30%, 1) !important;
        white-space: nowrap !important;
    }
    th {
        color: #ffffff !important;
    }
    .span-mr {
        margin: 0rem !important;
        padding: 0px;
        padding-top: 0.5rem;
    }
    .card {
        border: 2px solid hsla(190, 99%, 30%, 1) !important;
    }
    .button {
    border: 2px solid hsla(190, 99%, 30%, 1) !important;
    color: rgb(1, 127, 152);
    background: transparent !important;
    border-radius: 50px;
}
</style>
